import React, { Component, Fragment } from 'react';

import Map from './Map';
import L from 'leaflet';

L.RasterCoords = require('leaflet-rastercoords');

class App extends Component {
	state = {
		modalOpen: true
	};
	render() {
		return (
			<Fragment>
				{this.state.modalOpen && (
					<div
						style={{
							zIndex: 999999999999999,
							position: 'absolute',
							width: 900,
							height: 500,
							background: 'black',
							left: 'calc(50% - 450px)',
							top: 'calc(50% - 250px)',
							color: 'white',
							padding: 25
						}}
					>
						<h1>Gielinor - The Final Age</h1>
						<p>A collection of fan-made maps combined into one big map.</p>
						<h2>Credits (people who made their own custom map parts):</h2>
						<p>
							<a href="https://www.reddit.com/user/GentleTractor">
								https://www.reddit.com/user/GentleTractor
							</a>
							<br />
							<a href="https://www.reddit.com/user/darkblade273">
								https://www.reddit.com/user/darkblade273
							</a>
							<br />
							<a href="https://www.reddit.com/user/Terashkal">https://www.reddit.com/user/Terashkal</a>
							<br />
							<a href="https://www.reddit.com/user/Ellie_X">https://www.reddit.com/user/Ellie_X</a>
							<br />
							<a href="https://www.reddit.com/user/osrs_lartsi">
								https://www.reddit.com/user/osrs_lartsi
							</a>
							<br />
							<a href="https://www.reddit.com/user/TomMartow">https://www.reddit.com/user/TomMartow</a>
						</p>
						<p>
							<h2>Make your own map!</h2>
							<p>
								Visit{' '}
								<a
									style={{ color: 'white' }}
									href="https://www.reddit.com/r/GentleTractor/comments/4ziq7v/howto_guide_resources_for_making_fake_old_school/"
								>
									GentleTractor's Map Making Guide Here
								</a>{' '}
								for a good resource on making your own map!
								<br />
								Visit Mod Wests OSRS Map subreddit (for discussing and making maps) here:{' '}
								<a style={{ color: 'white' }} href="https://www.reddit.com/r/OSRSmaps/">
									https://www.reddit.com/r/OSRSmaps/
								</a>
							</p>
						</p>
						<a href="https://support.oldschool.gg/">Discord</a>
						<br />
						<a href="https://twitter.com/Magnaboyy">Twitter</a>
						<h2>
							Play Old School RuneScape for free at{' '}
							<a href="http://oldschool.runescape.com">http://oldschool.runescape.com</a>
						</h2>
						<div
							onClick={() => {
								this.setState({ modalOpen: false });
							}}
							style={{ position: 'absolute', top: 25, right: 25 }}
						>
							<button>Close</button>
						</div>
					</div>
				)}
				<Map animate />
			</Fragment>
		);
	}
}

export default App;
